'use strict';

import angular from 'angular';
import { Enum } from '../../enum/index';

export class ConfirmActivateInsurancePopupController {
  billData = {};
  forms = {
    insuranceDataForm: null
  };
  Enum = Enum;

  /*@ngInject*/
  constructor(mdPanelRef, $mdPanel, InsurancePerson, pageSettings, insuranceData, onClose, statuses,
              helper) {
    let vm = this;
    vm._mdPanelRef = mdPanelRef;
    vm.$mdPanel = $mdPanel;
    vm.theme = pageSettings.theme;

    vm.insuranceData = statuses;
    vm.insuranceData.activeFrom = insuranceData.activeFrom ? insuranceData.activeFrom : new Date();
    vm.insuranceData.activeTo = insuranceData.activeTo ? insuranceData.activeTo : new Date();
    if (!insuranceData.activeTo) {
      vm.insuranceData.activeTo.setDate(vm.insuranceData.activeTo.getDate() + insuranceData.insuranceOffer.validityPeriod);
    }
    console.log(vm.insuranceData);

    vm.save = () => {
      vm.forms.insuranceDataForm.$setSubmitted();

      if (vm.forms.insuranceDataForm.$valid) {
        InsurancePerson.changeStatuses(insuranceData.id, vm.insuranceData).then(() => {
          helper.showOperationSuccessToast();
          vm._mdPanelRef.close().then(function(mdPanelRefs) {
            onClose(mdPanelRefs, true);
          });
        }).catch(() => {
          helper.showOperationFailedToast();
        });
      }
    };
    vm.hide = function () {
      // vm._mdPanelRef.close().then(function(mdPanelRefs) {
      //   onClose(mdPanelRefs, 'ddd');
      // });

      let panelRef = vm._mdPanelRef;
      panelRef.destroy();
    };

  }
  cancel() {
    this._mdPanelRef.hide();
  }
}

export default angular.module('ngOskCrmApp.popup.confirmActivateInsurancePopupController', [])
  .controller('confirmActivateInsurancePopupController', ConfirmActivateInsurancePopupController)
  .name;



// WEBPACK FOOTER //
// ./client/app/shared/popup/confirm-activate-insurance-popup/confirm-activate-insurance-popup.controller.js